import { InfoOutlined as InfoIcon } from "@mui/icons-material";
import { FormGroup, Tooltip } from "@mui/material";
import { BookingRecordType, InvoiceKindEnum } from "pages/Booking/Booking.types";
import { AttendeeRecordType } from "pages/SharedRecords.types";
import { useEffect } from "react";
import { BooleanInput, InputProps, useTranslate } from "react-admin";
import { useFormContext, useWatch } from "react-hook-form";

type OverridePriceInputPropsType = {
  selectedBookings: BookingRecordType<AttendeeRecordType>[];
  invoiceKind: InvoiceKindEnum;
} & Omit<InputProps, "source">;

export default function OverridePriceInput({ selectedBookings, invoiceKind, ...props }: OverridePriceInputPropsType) {
  const translate = useTranslate();
  const smartCount = selectedBookings.length;
  const booleanInputLabel = translate("resources.invoices.fields.override_prices", { smart_count: smartCount });
  const tooltipTitle = translate("hints.invoice_override_prices", { smart_count: smartCount });
  const defaultValue = invoiceKind === InvoiceKindEnum.Correction;

  const { setValue, getValues } = useFormContext();
  const kind = useWatch<{ kind: InvoiceKindEnum }>({ name: "kind" });

  useEffect(() => {
    if (kind === InvoiceKindEnum.Correction) {
      setValue("override_prices", true);
    } else {
      setValue("override_prices", false);
    }
  }, [kind, setValue, getValues]);

  return (
    <FormGroup row sx={{ alignItems: "center" }}>
      <BooleanInput
        label={booleanInputLabel}
        source="override_prices"
        {...props}
        defaultValue={defaultValue}
        helperText={false}
      />
      <Tooltip arrow title={tooltipTitle}>
        <InfoIcon fontSize="small" />
      </Tooltip>
    </FormGroup>
  );
}
